export default function Select(props) {
	let {variant} = props;
	let classes = VARIANTS[variant || 'select']?.replace(/\s+/g, ' ');
	return <select {...props} className={classes || VARIANTS['select']}>{props.children}</select>
}

const VARIANTS = {
	select: `
		!dxp-border-gray-300
		!dxp-leading-5
		!dxp-m-0
		!dxp-px-3.5
		!dxp-py-2
		!dxp-rounded-lg
		!dxp-text-sm
		!dxp-w-full
		!focus-visible:dxp-border-purple
		!focus:dxp-border-purple
		!placeholder:dxp-text-sm
		!placeholder:dxp-text-tundora
	`,
}
